import React from "react";
import "../style/MySkills.css";
import AOS from "aos";

const MySkills = () => {
  return (
    <div data-aos="fade-in" className="mySkills_container">
      <div className="mySkills">
        <h1 className="skillTitle">Skills</h1>
        <h2>Languages</h2>
        <p>English</p>
        <p>Hebrew</p>

        <h2>Programming Languages</h2>
        <p>C#</p>
        <p>Javascript (ES6)</p>
        <p>HTML5</p>
        <p>CSS3/Sass</p>
        

        <h2>Frameworks</h2>
        <p>Node.js</p>
        <p>React.js</p>
        <p>MongoDB</p>
        <p>Express</p>

      </div>

      <div className="myTools">
        <h1 className="skillTitle"> Software and Tools</h1>
        <h2>Engine</h2>
        <p>Unity3D</p>

        <h2>Version Control</h2>
        <p>Git</p>
        <p>GitHub</p>

        <h2>Art</h2>
        <p>Photoshop</p>
        <p>Gimp</p>
        <p>Blender</p>

        <h2>Audio</h2>
        <p>Bfxr</p>
        <p>Audacity</p>

        <h2>Production</h2>
        <p>Trello</p>
        <p>Figma</p>
        <p>Microsoft Excel</p>

      </div>
    </div>
  );
};

export default MySkills;
